<template>
    <div>
        
        <div class="row">
            <div class="col s6"><h3>{{calDate.format("dddd, DD.MM.YYYY", "en")}}</h3></div></div>
        <div class="row">
            <div class="col s6">
                <h5 style="margin-top: 0px; text-transform: uppercase;">{{$t('menu.tasks')}}</h5>
            </div>
            <div class="col s6" style="text-align: right;">
                <a class="waves-effect waves-light btn" v-on:click="monthAgo()" style="border-radius-right: 0px;"> <i class="material-icons small">navigate_before</i> </a>
                <div class="waves-effect waves-light btn" style="border-radius: 0px;border: 1px solid #ddd;background-color: white !important;color: black;">{{calDate.format('MMMM YYYY', "en")}}</div>
                <a class="waves-effect waves-light btn" v-on:click="monthLater()" style="border-radius-left: 0px;">
                    <i class="material-icons small">navigate_next</i>
                </a>
            </div>
        </div>
        <table v-if="loaded">
            <tr>
                <th>{{$t('tasks.monday')}}</th>
                <th>{{$t('tasks.tuesday')}}</th>
                <th>{{$t('tasks.wednesday')}}</th>
                <th>{{$t('tasks.thursday')}}</th>
                <th>{{$t('tasks.friday')}}</th>
                <th>{{$t('tasks.saturday')}}</th>
                <th>{{$t('tasks.sunday')}}</th>
            </tr>
            <tr v-for="week in weeks">
                <td v-for="day in week" v-bind:style="{ 'border': date.isSame(day, 'day') ? '2px solid rgba(0,0,0,0.12)' : '1px solid rgba(0,0,0,0.12)'  }" style="height: 100px;">
                    <span v-bind:class="{ 'grey-text': calDate.isSame(day, 'month') == false }" v-if="listMonthsItems[day.format('DD-MM-YYYY')] == undefined || listMonthsItems[day.format('DD-MM-YYYY')].length == 0">{{day.format("D")}}</span>
                     <template v-else>
                      <dropdown>
                      <a class='dropdown-trigger btn' :data-target='"dropdown1" + day.format("DD-MM-YYYY")' style="border-radius: 20px;padding-left: 0px;padding-right: 0px;width: 32px;">{{day.format("D")}}</a>
                      
                      <ul :id='"dropdown1" + day.format("DD-MM-YYYY")' class='dropdown-content' style="min-width: 300px !important; margin-left: 40px;">
                        <li style="padding-top: 15px;padding-left: 15px;">{{day.format("D MMMM YYYY")}}</li>
                         <li class="divider" tabindex="-1"></li>
                        <li v-for="e in listMonthsItems[day.format('DD-MM-YYYY')]" style="padding: 5px;padding-left: 15px; text-overflow: ellipsis; white-space: nowrap;">
                          <div class="circle" style="display: inline-block; width: 35px;"  v-bind:class="{ 
                          intervention: e.kind == 'intervention',
                          inspection: e.kind == 'inspection',
                          installation: e.kind == 'installation',
                          other: e.typeof == 'other'}">
                            <template v-if="e.worker_initials[0] != undefined">{{e.worker_initials[0]}}</template>
                            <template v-else>.</template>
                          </div>
                          {{tasksnames[e.typeof].toUpperCase()}}
                          <template v-if="e.place != undefined">, {{e.place.name}}</template>
                          <template v-else-if="e.address">, {{e.address.street}}</template>
                        </li>
                      </ul>
                    </dropdown>
                      </template>
                </td>
            </tr>
        </table>
        <table v-else>
          <preloader n="7"/>
        </table>
    </div>
</template>
<script>
import moment from 'moment'
import axios from 'axios'
moment.locale('en')
export default {
    data: function() {
        return {
            date: moment(),
            weeks: [],
            calDate: moment(),
            loaded: false,
            tasksnames: { 'intervention': this.$t('tasks.kindnames.intervention'), 'inspection': this.$t('tasks.kindnames.inspection'), "installation": this.$t('tasks.kindnames.installation'), 'other': this.$t('tasks.kindnames.other') },
            intervention_types: { 'deratization': this.$t('tasks.intervention_names.deratization'), 'disinfection': this.$t('tasks.intervention_names.disinfection'), 'disinsection': this.$t('tasks.intervention_names.disinsection'), 'other': this.$t('tasks.intervention_names.other') },
        }
    },
    created() {
        this.generateWeeks();
        this.loadTasks()
    },
    computed: {
        listMonthsItems() {
            var out = {};
            var that = this;
            var sow = this.calDate.clone().startOf('month').startOf('week');
            var eow = this.calDate.clone().endOf('month').endOf('week');
            var itms = this.tasks;
            for (var m = moment(sow); m.isBefore(eow); m.add(1, 'days')) {
                out[m.format('DD-MM-YYYY')] = _.filter(
                    itms,
                    function(item) {
                        return moment(item.startsAt).isSame(m, 'day')
                    });
            }
            return out
        },
    },
    methods: {
        async loadTasks() {
            this.loaded = false;
            this.fromload = moment().subtract(1, 'months').startOf('month').unix();
            this.toload = moment().add(1, 'months').endOf('month').unix();
            var response = await axios.get('/tasks/' + this.fromload + '/' + this.toload + '.json')
            this.tasks = response.data;
            for (var i in this.tasks) {
                var task = this.tasks[i];
                task.startsAt = moment(task.startsAt).format('YYYY-MM-DDTHH:mm');
                task.endsAt = moment(task.endsAt).format('YYYY-MM-DDTHH:mm');
            }
            this.loaded = true;
            this.calDate = this.calDate.clone()
            this.generateWeeks();
        },
        async loadFragmentIfNeeded(f, t) {
            if (this.fromload <= f.unix() && this.toload >= t.unix()) {
            } else {
                this.loaded = false;
                var response = await axios.get('/tasks/' + f.unix() + '/' + t.unix() + '.json');
                this.fromload = f.unix();
                this.toload = t.unix();
                this.tasks = response.data;
                this.loaded = true;
            }
            this.calDate = this.calDate.clone()
            this.$forceUpdate();
        },
        generateWeeks() {
            var start = this.calDate.clone().startOf('month').startOf('week')
            var end = this.calDate.clone().endOf('month').endOf('week')
            var out = []
            var startWeek = start.week();
            var endWeek = end.week();
            start.add(-1, 'days')
            if (startWeek > endWeek) {
                endWeek = endWeek + moment().weeksInYear()
            }
            for (var week in _.range(0, 6)) {
                out.push([
                    start.add(1, 'days').clone(),
                    start.add(1, 'days').clone(),
                    start.add(1, 'days').clone(),
                    start.add(1, 'days').clone(),
                    start.add(1, 'days').clone(),
                    start.add(1, 'days').clone(),
                    start.add(1, 'days').clone()
                ])
            }
            this.weeks = out
        },

        monthAgo: function() {
            this.calDate.add(-1, 'months');
            this.loaded = false
            this.generateWeeks();
            this.loaded = true;
            // this.$forceUpdate();
            this.loadFragmentIfNeeded(this.calDate.clone().startOf('month'), this.calDate.clone().endOf('month'));
        },
        monthLater: function() {
            this.calDate.add(1, 'months');
            this.loaded = false
            this.generateWeeks();
            this.loaded = true;
            // this.$forceUpdate();
            this.loadFragmentIfNeeded(this.calDate.clone().startOf('month'), this.calDate.clone().endOf('month'));
        },

    }

}
</script>
<style scoped>
.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

nav {
    background-color: #626262;
    height: 100px;
}

nav a {
    margin: 15px;
}

th {
    width: 14.28%;
    text-align: center;
}

td {
    vertical-align: top;
}

.btn {
    background-color: #C22026 !important;
}
.intervention {
    background-color: rgba(244, 60, 250, 0.25);
}

.inspection {
    background-color: rgba(250, 244, 60, 0.25);
}

.installation {
    background-color: rgba(66, 250, 60, 0.25);
}

.other {
    background-color: rgba(60, 117, 250, 0.25);
}
.circle{
  line-height: 35px;
  text-align: center;
  border: 1px solid;
}
</style>
